<template>

  <div style="height:100%">
    <Row :gutter="16" style="height: calc(70% - 60px)">
      <Col span="6" style="height: 100%">
      <div class="block" style="height: calc(55% - 20px)">
        <h2 class="title">申请用车<startEnd @startend="$refs.zongzichan.reach($event)"></startEnd></h2>
        <div class="chartWrap">
          <zongzichan ref="zongzichan"></zongzichan>
        </div>
      </div>
      <div class="block" style="height: calc(45% - 20px)">
        <h2 class="title">
          派车工单<startEnd @startend="$refs.youhao.reach($event)"></startEnd>
        </h2>
        <div class="chartWrap">
          <youhao ref="youhao"></youhao>
        </div>
      </div>
      </Col>
      <Col span="12" style="height: 100%">
      <div class="block" style="position: relative; height: calc(100% - 20px)">
        <h2 class="title">车辆运行分布</h2>
        <div class="chartWrap">
         <ecmap ref="ecmap"></ecmap>
        </div>
        
      </div>
      </Col>
      <Col span="6" style="height: 100%">
      <div class="block" style="height: calc(60% - 20px)">
        <h2 class="title">车辆状态</h2>
        <div class="chartWrap">
          <saodiche></saodiche>
        </div>
      </div>
      <div class="block" style="height: calc(40% - 20px)">
        <h2 class="title">
          驾驶员状态<startEnd v-show="false" @startend="$refs.paigongxiangmu.reach($event)"></startEnd>
        </h2>
        <div class="chartWrap">
          <paigongxiangmu ref="paigongxiangmu"></paigongxiangmu>
        </div>
      </div>
      </Col>
    </Row>
    <Row :gutter="16" style="height: calc(30% - 20px)">
      <Col span="6" style="height: 100%">
      <div class="block" style="height: calc(100% - 20px)">
        <h2 class="title">
          车辆排名 
          <tab @now="$refs.licheng.reachType($event)"></tab>
          <startEnd @startend="$refs.licheng.reach($event)"></startEnd>
        </h2>
        <div class="chartWrap">
          <licheng ref="licheng"></licheng>
        </div>
      </div>
      </Col>
      <Col span="6" style="height: calc(100% - 20px)">
      <div class="block" style="height: 100%">
        <h2 class="title">
          近一年油耗费用排名<startEnd v-show="false" @startend="$refs.xunchache.reach($event)"></startEnd>
        </h2>
        <div class="chartWrap">
          <xunchache ref="xunchache"></xunchache>
        </div>
      </div>
      </Col>
      <Col span="6" style="height: calc(100% - 20px)">
      <div class="block" style="height: 100%">
        <h2 class="title">
          近一年维修费用排名<startEnd v-show="false" @startend="$refs.cheliangbaojing.reach($event)"></startEnd>
        </h2>
        <div class="chartWrap">
          <cheliangbaojing ref="cheliangbaojing"></cheliangbaojing>
        </div>
      </div>
      </Col>
      <Col span="6" style="height: calc(100% - 20px)">
      <div class="block" style="height: 100%">
        <h2 class="title">
          驾驶员排名
          <tab @now="$refs.paigongzonglan.reachType($event)"></tab>
          <startEnd @startend="$refs.paigongzonglan.reach($event)"></startEnd>
        </h2>
        <div class="chartWrap">
          <paigongzonglan ref="paigongzonglan"></paigongzonglan>
        </div>
      </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import startEnd from "./statrEnd.vue";
import tab from "./tab.vue";
import youhao from "./youhao.vue";
import licheng from "./licheng.vue";
import xunchache from "./xunchache.vue";
import saodiche from "./saodiche.vue";
import zongzichan from "./pie";
import ecmap from "./ecmap.vue";
import paigongzonglan from "./paigongzonglan.vue";
import cheliangbaojing from "./cheliangbaojing.vue";
import paigongxiangmu from "./paigongxiangmu.vue";
import mapMenu from "./mapMenu.vue";
export default {
  components: {
    zongzichan,
    startEnd,
    youhao,
    licheng,
    xunchache,
    saodiche,
    ecmap,
    paigongzonglan,
    cheliangbaojing,
    paigongxiangmu,
    mapMenu,
    tab
  },

  data() {
    return {};
  },
  methods: {
    reMapMenu(v, m) {
      return;
      if (m == "巡查点") {
        setTimeout(() => {
          this.$refs.ecmap.showLjt(v);
        }, 1500);
      } else if (m == "作业人员") {
        setTimeout(() => {
          this.$refs.ecmap.showpersons(v);
        }, 1500);
      } else if (m == "扫地车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showXisao(v);
        }, 1500);
      } else if (m == "作业网格") {
        this.$refs.ecmap.showWangge(v);
      } else if (m == "巡查车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showQingyun(v);
        }, 1500);
      } else if (m == "作业线路") {
        setTimeout(() => {
          this.$refs.ecmap.showline(v);
        }, 500);
      }
    },
    groups(v) {
      if (v[0].name == "广东华政建设有限公司") {
        v = [];
      }
      //this.$refs.paigongxiangmu.groups(v);
      //this.$refs.paigongzonglan.groups(v);
      // this.$refs.licheng.groups(v);
      //this.$refs.youhao.groups(v);
      //this.$refs.zongzichan.getData(v);
      //this.$refs.mapMenu.groups(v);
    },
  },
  computed: {},

  mounted() {
    //let screenWidth = window.innerWidth;

  },
};
</script>

<style lang="">
#big {
  width: 1920px;
  height: 1080px;
  padding: 0 16px;
  transform-origin: 0 0;
}
#big p,
#big div {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/index.vue